<template>
    <div class="container p-0">
        <div class="grid justify-content-center pt-2">
            <slot name="cards">

            </slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default  defineComponent({
    name: 'StatContainer',
    components: {
        
    },
    data() {
        return {
        }
    },
    methods: {
    },    
})
</script>
<style src="./stat-container.scss" lang="scss" scoped></style>